import React from 'react'

export const PT300 = (): JSX.Element => <div>PT300 Simulator</div>
